<main id="pagebody" class="container" >
  <div id="pagebodycontent" class="page-content">
    <section class="mat-typography">
      <div class="row">
        <div class="td-loading-container" *ngIf="loading">
          <td-loading-message></td-loading-message>
        </div>
        <ng-container *ngIf="!loading">
          <ng-container [ngSwitch]="fuseAction">            
            <div *ngSwitchCase="'Security.AngLogin'">
              <app-login-portal [primaryColor]="primaryColor" [tdSupportLogin]="false"></app-login-portal>
            </div>
            <div *ngSwitchCase="'Security.AngSupportLogin'">
              <app-login-portal [primaryColor]="primaryColor" [tdSupportLogin]="true"></app-login-portal>
            </div>
            <div *ngSwitchCase="'Students.AngApply'">
              <app-login-portal [primaryColor]="primaryColor" [cycleItinerary]="true"></app-login-portal>
            </div>
            <div *ngSwitchDefault>
              <h1>Invalid route</h1>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </section>
  </div>
</main>
<div id="td-section-to-print"></div>
